<template>
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM9.35355 6.35355C9.54882 6.15829 9.54882 5.84171 9.35355 5.64645C9.15829 5.45118 8.84171 5.45118 8.64645 5.64645L5.64645 8.64645C5.45118 8.84171 5.45118 9.15829 5.64645 9.35355L8.64645 12.3536C8.84171 12.5488 9.15829 12.5488 9.35355 12.3536C9.54882 12.1583 9.54882 11.8417 9.35355 11.6464L7.20711 9.5H10C10.9283 9.5 11.8185 9.86875 12.4749 10.5251C13.1313 11.1815 13.5 12.0717 13.5 13V14C13.5 14.2761 13.7239 14.5 14 14.5C14.2761 14.5 14.5 14.2761 14.5 14V13C14.5 11.8065 14.0259 10.6619 13.182 9.81802C12.3381 8.97411 11.1935 8.5 10 8.5H7.20711L9.35355 6.35355Z"
    ></path>
  </svg>
</template>
